/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateLanguageRequest = {
    language: UpdateLanguageRequest.language;
};
export namespace UpdateLanguageRequest {
    export enum language {
        EN = 'en',
        RU = 'ru',
    }
}

